module.exports = __webpack_public_path__ + "img/gc2.614f2e1f.png";